// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-bar input{\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  background-color: #EFEFEF;\n  width:100%;\n}\n@media  (max-width: 660px) {\n.search-bar input{\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n}\n}\n", ""]);
// Exports
module.exports = exports;
